import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { greys } from 'assets/themes/theme-default'

const LinkStyled = styled(Link)`
  &&& {
    color: ${props => props.theme.colors.color1.bg};

    .no-color {
      color: ${greys.dark1};
    }
    .material-icons {
      color: ${props => props.theme.colors.color1.bg};
    }
  }
`

export default LinkStyled
